
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="示例" fileName="basic.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-table :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; /&gt;
        &lt;div class=&quot;table-pagination&quot;&gt;
            &lt;ve-pagination
                :total=&quot;totalCount&quot;
                :page-index=&quot;pageIndex&quot;
                :page-size=&quot;pageSize&quot;
                @on-page-number-change=&quot;pageNumberChange&quot;
                @on-page-size-change=&quot;pageSizeChange&quot;
            /&gt;
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;style&gt;
    .table-pagination {
        margin-top: 20px;
        text-align: right;
    }
&lt;/style&gt;

&lt;script&gt;
    // Simulation table data from database
    let DB_DATA = [];

    export default {
        data() {
            return {
                // page index
                pageIndex: 1,
                // page size
                pageSize: 10,
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;#&quot;,
                        align: &quot;center&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return (this.pageIndex - 1) * this.pageSize + rowIndex + 1;
                        },
                    },
                    { field: &quot;name&quot;, key: &quot;b&quot;, title: &quot;Name&quot;, align: &quot;center&quot; },
                    { field: &quot;date&quot;, key: &quot;c&quot;, title: &quot;Date&quot;, align: &quot;left&quot; },
                    { field: &quot;hobby&quot;, key: &quot;d&quot;, title: &quot;Hobby&quot;, align: &quot;left&quot; },
                    { field: &quot;address&quot;, key: &quot;e&quot;, title: &quot;Address&quot;, width: &quot;&quot; },
                ],
            };
        },
        computed: {
            // table data
            tableData() {
                const { pageIndex, pageSize } = this;
                return DB_DATA.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
            },
            // total count
            totalCount() {
                return DB_DATA.length;
            },
        },
        methods: {
            // page number change
            pageNumberChange(pageIndex) {
                this.pageIndex = pageIndex;
            },

            // page size change
            pageSizeChange(pageSize) {
                this.pageIndex = 1;
                this.pageSize = pageSize;
            },

            // Simulation table data
            initDatabase() {
                DB_DATA = [];
                for (let i = 0; i &lt; 1000; i++) {
                    DB_DATA.push({
                        name: &quot;John&quot; + i,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot; + i,
                        address: &quot;No.1 Century Avenue, Shanghai&quot; + i,
                    });
                }
            },
        },
        created() {
            this.initDatabase();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData}}),_vm._v(" "),_c('div',{staticClass:"table-pagination"},[_c('ve-pagination',{attrs:{"total":_vm.totalCount,"page-index":_vm.pageIndex,"page-size":_vm.pageSize},on:{"on-page-number-change":_vm.pageNumberChange,"on-page-size-change":_vm.pageSizeChange}})],1)],1)]],2)}
var staticRenderFns = []

  
    // Simulation table data from database
    let DB_DATA = [];

    const democomponentExport = {
        data() {
            return {
                // page index
                pageIndex: 1,
                // page size
                pageSize: 10,
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "#",
                        align: "center",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return (this.pageIndex - 1) * this.pageSize + rowIndex + 1;
                        },
                    },
                    { field: "name", key: "b", title: "Name", align: "center" },
                    { field: "date", key: "c", title: "Date", align: "left" },
                    { field: "hobby", key: "d", title: "Hobby", align: "left" },
                    { field: "address", key: "e", title: "Address", width: "" },
                ],
            };
        },
        computed: {
            // table data
            tableData() {
                const { pageIndex, pageSize } = this;
                return DB_DATA.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
            },
            // total count
            totalCount() {
                return DB_DATA.length;
            },
        },
        methods: {
            // page number change
            pageNumberChange(pageIndex) {
                this.pageIndex = pageIndex;
            },

            // page size change
            pageSizeChange(pageSize) {
                this.pageIndex = 1;
                this.pageSize = pageSize;
            },

            // Simulation table data
            initDatabase() {
                DB_DATA = [];
                for (let i = 0; i < 1000; i++) {
                    DB_DATA.push({
                        name: "John" + i,
                        date: "1900-05-20",
                        hobby: "coding and coding repeat" + i,
                        address: "No.1 Century Avenue, Shanghai" + i,
                    });
                }
            },
        },
        created() {
            this.initDatabase();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      .table-pagination {
        margin-top: 20px;
        text-align: right;
    }
    </style>
  